import React from 'react';

import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Box, IconButton } from '@mui/material';

import { formatDateSlashes } from '~/services/TimeService';

import type { CharterFeederSheetRow } from '../CharterFeederPricesTypes';

interface DateCellProps {
  row: CharterFeederSheetRow;
  rawValue: unknown;
  isViewMode: boolean;
  onRequestClear: (row: CharterFeederSheetRow) => void;
}

function formatDateLabel(value: unknown): string {
  const formatted = formatDateSlashes(String(value));
  return formatted === 'Invalid Date' ? String(value ?? '') : formatted;
}

export { formatDateLabel };

export default function DateCell({ row, rawValue, isViewMode, onRequestClear }: DateCellProps): React.JSX.Element {
  const dateLabel = formatDateLabel(rawValue);

  if (isViewMode) {
    return (
      <Box sx={{ pl: 3.5, width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
        <Box component="span" sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
          {dateLabel}
        </Box>
      </Box>
    );
  }

  const clearLabel = `Clear feeder values for ${row.date}|${row.originAirportCode}|${row.destinationAirportCode}`;

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton
        size="small"
        color="error"
        aria-label={clearLabel}
        onClick={(event) => {
          event.stopPropagation();
          onRequestClear(row);
        }}
      >
        <DeleteSweepIcon fontSize="small" />
      </IconButton>
      <Box component="span" sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
        {dateLabel}
      </Box>
    </Box>
  );
}
